module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='36' height='36' viewBox='0 0 36 36'%3E %3Cimage id='Vector_Smart_Object' data-name='Vector Smart Object' y='3' width='36' height='29' xlink:href='data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAdCAYAAADCdc79AAAAlklEQVRYhe3VMQ7AIAgF0J94s16maU/QC3nFDl3swmCaKjrAd4DEyUDeAh/kugBkAIkNgWCKPDqqxtBRf5gatQymyH9gAhOYwASmVzuAbRXMIc33JMoEc36GjKJMMK2hGspsm3JnaAtlutppEuVyZ0ZRrkdPQz2MC6yhKHEwi3LJplGUa1BqKFeMhqJgWigq5ouyxQB4AdsS/czo2TltAAAAAElFTkSuQmCC'/%3E %3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/popup_checkmark.svg
// module id = 916
// module chunks = 0